import React from "react";
import "./TermsConditions.css";
import { useNavigate } from "react-router-dom";

const TermsConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="container py-5 terms-conditions">
      <div className="mb-4">
        <button
          className="btn btn-outline-primary"
          onClick={() => navigate("/")}
        >
          ⟵ Back to Home
        </button>
      </div>
      <h2 className="text-center fw-bold mb-4">Terms & Conditions</h2>

      <h5 className="fw-bold mt-4">1. Service Overview</h5>
      <ul>
        <li>
          One-page <strong>responsive web application</strong>.
        </li>
        <li>
          <strong>Admin panel</strong> to update content and media.
        </li>
        <li>
          Hosted on a <strong>secured server</strong> with a custom subdomain
          under <code>webpge.com</code>
        </li>
        <li>
          <strong>Ongoing monthly maintenance</strong> included.
        </li>
      </ul>

      <h5 className="fw-bold mt-4">2. Subscription & Pricing</h5>
      <ul>
        <li>
          <strong>Annual subscription model</strong>.
        </li>
        <li>
          Pricing starts at <strong>$15/year</strong> and may vary by country
          due to hosting, tax, or operational costs.
        </li>
        <li>
          Includes{" "}
          <strong>
            hosting, admin panel, subdomain, and technical support
          </strong>
          .
        </li>
      </ul>

      <h5 className="fw-bold mt-4">3. Monthly Maintenance</h5>
      <p>Routine monthly maintenance may include:</p>
      <ul>
        <li>Server updates</li>
        <li>Security patches</li>
        <li>Performance improvements</li>
        <li>Minor bug fixes</li>
      </ul>

      <h5 className="fw-bold mt-4">4. Content & Admin Panel</h5>
      <ul>
        <li>
          Clients manage content via the <strong>admin panel</strong>.
        </li>
        <li>You are solely responsible for all content you upload.</li>
        <li>
          <strong>Offensive or illegal content</strong> is strictly prohibited.
        </li>
      </ul>

      <h5 className="fw-bold mt-4">5. Ownership & License</h5>
      <ul>
        <li>
          The codebase and system architecture remain the property of{" "}
          <strong>Lagran Software Solutions Pvt Ltd</strong>.
        </li>
        <li>
          Users are granted a{" "}
          <strong>non-transferable, limited-use license</strong> valid during
          the subscription period.
        </li>
      </ul>

      <h5 className="fw-bold mt-4">6. Termination</h5>
      <ul>
        <li>
          Either party may terminate the service with{" "}
          <strong>7 days’ written notice</strong>.
        </li>
        <li>
          <strong>No refunds</strong> will be issued for early cancellation.
        </li>
        <li>
          Service will be <strong>suspended</strong> upon termination or
          non-renewal.
        </li>
      </ul>

      <h5 className="fw-bold mt-4">7. Liability & Disclaimer</h5>
      <ul>
        <li>
          Lagran is <strong>not liable</strong> for business loss,
          content-related issues, or third-party disruptions.
        </li>
      </ul>

      <h5 className="fw-bold mt-4">8. Governing Law</h5>
      <ul>
        <li>
          These terms are governed by the laws of <strong>India</strong>.
        </li>
        <li>
          Jurisdiction: <strong>Courts of Andhra Pradesh</strong>.
        </li>
      </ul>

      <p className="mt-4">
        <strong>
          By subscribing to our services, you agree to abide by the above terms
          and conditions.
        </strong>
      </p>
    </div>
  );
};

export default TermsConditions;
